import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Building`}</strong>{` compiles your application with modern features like server-side rendering, route based code splitting (`}<a parentName="p" {...{
        "href": "/blog/2019-04-02-behind-the-scenes-what-makes-gatsby-great/"
      }}>{`and more!`}</a>{`) for great performance out of the box.`}</p>
    <p>{`During the build (when you run `}<inlineCode parentName="p">{`gatsby build`}</inlineCode>{` or `}<inlineCode parentName="p">{`gatsby develop`}</inlineCode>{`), data is fetched and combined into a GraphQL schema with a static snapshot of all data your site needs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      